import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import { com } from '@eidu/form'
import KindInput from '../input/KindInput'
import LabelDisplay from './LabelDisplay'
import { getTypeDisplayName } from '../../util/entityType/typeNameSchema'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import FieldDisplay from './FieldDisplay'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

type FieldsStackProps = {
  entityType: EntityType
  entityTypes: readonly EntityType[]
  onEdit: () => void
}

const FieldsStack = ({ entityType, entityTypes, onEdit }: FieldsStackProps) => {
  const fields = entityType.fields.asJsReadonlyArrayView()

  const primaryLabel = entityType.label.primary
  const secondaryLabel = entityType.label.secondary || undefined

  return (
    <Stack spacing={3}>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h4">{getTypeDisplayName(entityType.name)}</Typography>
        <Button color="primary" startIcon={<EditOutlinedIcon />} onClick={onEdit}>
          EDIT
        </Button>
      </Stack>

      {fields.length > 0 && (
        <>
          <Typography variant="h5">Kind</Typography>
          <KindInput kind={entityType.kind} />
        </>
      )}

      {fields.length > 0 && <Typography variant="h5">Fields</Typography>}
      {fields.map((field) => (
        <Stack key={field.id.toString()}>
          <FieldDisplay availableEntityTypes={entityTypes} field={field} />
        </Stack>
      ))}
      {fields.length > 0 && (
        <LabelDisplay fields={fields} primaryLabel={primaryLabel} secondaryLabel={secondaryLabel} />
      )}
    </Stack>
  )
}

export default FieldsStack
